const PrivacyCheckbox = ({ checkboxValue, handleCheckboxChange, links }) => {
    return (
        <div className="modal-box__contact-form__disclaimer disclaimer privacy">
            <label className="custom-checkbox">
                <input
                    type="checkbox"
                    name="privacy"
                    checked={checkboxValue}
                    onChange={(e) => handleCheckboxChange(e)}
                />
                <span className="checkmark"></span>
            </label>
            <span className="checkbox-text">
                He leído y acepto la{" "}
                <a href={links.tnc_page} target="_blank">
                    política de privacidad
                </a>{" "}
                de mis datos personales.
            </span>
        </div>
    );
};

export default PrivacyCheckbox;
